<template>
  <form v-on:submit.prevent="onSubmit">
    <div class="modal-header">
      <h4 class="modal-title">Add Tender Stage</h4>
    </div>

    <div class="modal-body">
      <div class="form-group">
        <label for="tenderStageName">Name <span class="red-dot ml-3"></span></label>
        <input id="tenderStageName" name="tenderStageName" type="text" class="form-control" :class="{ 'is-invalid': errors.has('tenderStageName') }"
          autocomplete="off" placeholder="Name" v-model="tenderStage.name" v-validate="'required'" data-vv-as="Name" />
        <div class="invalid-feedback">The Name field is required.</div>
      </div>
      <div class="form-group">
        <label for="tenderStageCode">Code <span class="red-dot ml-3"></span></label>
        <input id="tenderStageCode" name="tenderStageCode" type="text" class="form-control" :class="{ 'is-invalid': errors.has('tenderStageCode') }"
          autocomplete="off" placeholder="Code" v-model="tenderStage.code" v-validate="'required'" data-vv-as="Code" />
        <div class="invalid-feedback">The Code field is required.</div>
      </div>
      <div class="form-group">
        <label for="tenderStageSortOrder">Sort Order <span class="red-dot ml-3"></span></label>
        <input id="tenderStageSortOrder" name="tenderStageSortOrder" type="text" class="form-control" :class="{ 'is-invalid': errors.has('tenderStageSortOrder') }"
          autocomplete="off" placeholder="Sort Order" v-model="tenderStage.sortOrder" v-validate="'required'" data-vv-as="Sort Order" />
        <div class="invalid-feedback">The Sort Order field is required.</div>
      </div>
    </div>

    <div class="modal-footer">
      <button type="submit" class="btn btn-success">Save</button>
      <button type="button" class="btn btn-secondary" @click="closeModal">Close</button>
    </div>
  </form>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Toast from "@/utils/toast";

export default {
  name: 'contact-type',
  data: function () {
    return {
      isEdit: false,
      tenderStage: {}
    }
  },
  computed: {
    ...mapGetters(["getTenderStage"])
  },
  mounted: function() {
    this.tenderStage = { ...this.getTenderStage };
    this.isEdit = !!this.tenderStage.id;
    this.$validator.reset();
  },
  methods: {
    async onSubmit() {
      var isFormValid = await this.$validator.validate();

      if (!isFormValid) {
        return;
      }

      this.saveTenderStage({ data: this.tenderStage, isEdit: this.isEdit })
        .then(() => {
          Toast.success(this, "Successfully saved!");
          this.$bvModal.hide("bv-modal-tender-stage");
          this.closeModal();
        })
        .catch(() => {
          Toast.danger(this, "Oops! There was an error.");
          this.closeModal();
        });
    },
    closeModal() {
      this.$bvModal.hide("bv-modal-tender-stage");
    },
    ...mapActions(["saveTenderStage"])
  }
}
</script>
